import { Card, CardProps, Stack, styled } from "@mui/material";
import { rgba } from "polished";
import React from "react";

export const MOBILE_RESOLUTION = 768;
export const DEFAULT_PAGE_SIZE_FOR_ORDER = 250;
export const MIN_SELECTOR_YEAR = 2018;

interface IOrderHistoryCardProps extends CardProps {
  isMobile: boolean;
  children?: React.ReactNode;
}

export const OrderHistoryCard = styled(({ isMobile, ...props }: IOrderHistoryCardProps) => <Card {...props} />)<{
  isMobile: boolean;
}>`
  background: ${props => props.theme.modernCardBackground};
  border-color: ${props => props.theme.modernCardBorderColor};
  border-radius: ${props => props.theme.modernCardRadius}px;
  border-style: solid;
  border-width: ${props => props.theme.modernCardBorder}px;
  box-shadow: none;
  padding: 20px ${props => (props.isMobile ? "20px" : "0")} 20px 20px;

  // Fine-tuning dropdown
  & [class*="year-select"] {
    & select {
      width: 92px;
    }
    & svg {
      right: 15px;
    }
  }
`;

export const SelectContainer = styled("div")`
  & [class*="year-select"] {
    & select {
      width: 92px;
    }
    & svg {
      right: 15px;
    }
  }
`;

export const NoOrdersContainer = styled(Stack)`
  background: ${props => rgba(props?.theme?.modernPageBackground!, 0.5)};
  border-radius: 25px;
  height: 130px;
  margin-right: 20px;
  padding: 15px 20px;

  p {
    color: ${props => props.theme.modernBodyFontColor};
  }
`;
